import PropTypes from 'prop-types'
import styled from '@emotion/styled'

import { Skeleton } from 'lmcv/components/Skeleton'

import { baseStyles, imageStyles, avatarStyles, avatarBigStyles } from './styles'

const PhotoElement = styled('div')(baseStyles, avatarStyles, avatarBigStyles)
const ImageElement = styled('div')(imageStyles)
function Avatar ({ image, name, big, loading }) {
  return (
    <PhotoElement big={big}>
      {loading
        ? (<Skeleton width="100%" height="100%" />)
        : image
          ? (<ImageElement image={image} />)
          : (name.substring(0, 1))
      }
    </PhotoElement>
  )
}

Avatar.propTypes = {
  name: PropTypes.string,
  image: PropTypes.string,
  big: PropTypes.bool,
  loading: PropTypes.bool
}

Avatar.defaultProps = {
  big: false,
  loading: false
}

export default Avatar
